export default __webpack_public_path__ + "static/media/EMprint Bold.4f70a05a.woff2";